import { render, staticRenderFns } from "./LeaderCard2.vue?vue&type=template&id=13cbb760&scoped=true&"
import script from "./LeaderCard2.vue?vue&type=script&lang=js&"
export * from "./LeaderCard2.vue?vue&type=script&lang=js&"
import style0 from "./LeaderCard2.vue?vue&type=style&index=0&id=13cbb760&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cbb760",
  null
  
)

export default component.exports